import React from 'react';
import styled from 'styled-components';
import {
  colors,
  fonts,
  breakpoints,
  containerStyle,
  icones,
  isOpenNowFromHoraires,
} from '../annuaire/designSystem';
import {
  fixerLiteHasOpeningHours,
  fixerLiteOpenNow,
  isFixerLiteEnabled,
  fixerLiteServices,
} from '../../annuaire/bookingState';

const BannerWrapper = styled.div`
  background-color: ${colors.vertPastel};
  padding: 28px 0;

  @media (min-width: ${breakpoints.mobile}) {
    padding: 36px 0;
  }
`;

const Container = styled.div`
  ${containerStyle}
`;

const TrustItems = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
  align-items: center;
`;

const TrustItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: center;
  justify-content: center;
`;

const TrustIcon = styled.img`
  width: 36px;
  height: 36px;
  object-fit: contain;
  flex-shrink: 0;
`;

const TrustTextBlock = styled.div`
  text-align: left;
`;

const TrustText = styled.div`
  font-family: ${fonts.body};
  font-weight: 600;
  color: ${colors.textDark};
  font-size: 1rem;
`;

const TrustSubtext = styled.div`
  font-family: ${fonts.body};
  font-size: 0.85rem;
  color: ${colors.textSecondary};
`;

export default function TrustBanner({ shop }) {
  const details = shop.details || {};
  const noteGoogle = details.note_google;
  const nbAvis = details.nb_avis_google;
  // FIXERLIGHT-071 : pour un atelier Fixer Lite, `ShopPrestations` (plus haut
  // sur la même fiche) affiche le catalogue du compte (`fixer_lite.services`),
  // jamais `details.services` (les libellés Google/Airtable, absents d'un
  // atelier Fixer Lite créé par ShopCreator::create()). Ce compteur doit
  // porter sur la MÊME liste que ce qui est réellement affiché, sinon il dit
  // « 0 services proposés » sous des prestations bien réelles.
  const servicesCount = isFixerLiteEnabled(shop)
    ? fixerLiteServices(shop).length
    : (details.services || []).length;
  let statut = details.statut_etablissement || 'Inconnu';
  if (statut === 'Ouvert') {
    // FIXERLIGHT-068 : un atelier Fixer Lite règle ses horaires dans ses
    // Réglages, pas dans les horaires Google (vides pour ce type d'atelier) —
    // sinon ce badge affichait « Ouvert » à côté d'un tableau « Non renseigné ».
    // Le garde est `fixerLiteHasOpeningHours`, pas `isFixerLiteEnabled` seul :
    // un compte activé sans gabarit réglé doit retomber sur Google, sinon ce
    // badge dirait « Fermé » sur un atelier qui ne l'est pas.
    const openNow = fixerLiteHasOpeningHours(shop)
      ? fixerLiteOpenNow(shop)
      : isOpenNowFromHoraires(details.horaires);
    if (openNow === true) statut = 'Ouvert';
    else if (openNow === false) statut = 'Fermé';
  }

  return (
    <BannerWrapper>
      <Container>
        <TrustItems>
          {noteGoogle && (
            <TrustItem>
              <TrustIcon src={icones.pouceOk} alt="Excellente note" />
              <TrustTextBlock>
                <TrustText>{noteGoogle}/5</TrustText>
                <TrustSubtext>sur {nbAvis || 0} avis</TrustSubtext>
              </TrustTextBlock>
            </TrustItem>
          )}
          <TrustItem>
            <TrustIcon src={icones.shop} alt="Services" />
            <TrustTextBlock>
              <TrustText>{servicesCount} services</TrustText>
              <TrustSubtext>propos&eacute;s</TrustSubtext>
            </TrustTextBlock>
          </TrustItem>
          <TrustItem>
            <TrustIcon src={icones.calendrier} alt="Disponibilit&eacute;" />
            <TrustTextBlock>
              <TrustText>{statut}</TrustText>
              <TrustSubtext>aujourd&apos;hui</TrustSubtext>
            </TrustTextBlock>
          </TrustItem>
        </TrustItems>
      </Container>
    </BannerWrapper>
  );
}
